import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { PaymentConfirmation } from '../../../models/psychometric-test/psychometric-test.model';
import { MessageService } from 'primeng/api';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
    selector: 'app-payment-confirmation',
    standalone: true,
    imports: [
        CommonModule,
        CardModule,
        ButtonModule
    ],
    templateUrl: './payment-confirmation.component.html',
    styleUrls: ['./payment-confirmation.component.scss']
})
export class PaymentConfirmationComponent {
    @Input() paymentConfirmation: PaymentConfirmation | null = null;
    @Output() testLaunch = new EventEmitter<void>();

    constructor(private messageService: MessageService) { }

    onGoToTestLaunch(): void {
        this.testLaunch.emit();
    }

    downloadReceipt(): void {
        const receiptPdfAreaElement = document.getElementById('receiptPdfArea');
        if (!receiptPdfAreaElement) {
            this.messageService.add({
                severity: 'error',
                summary: 'Receipt Downloading Error',
                detail: 'Failed to download receipt'
            });
            return;
        }

        (document as any).fonts.ready.then(() => {

            html2canvas(receiptPdfAreaElement, {
                scale: 3,
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                logging: false,
                removeContainer: true,

                onclone: (clonedDoc: any) => {

                    const receiptPdfAreaElement = clonedDoc.getElementById('receiptPdfArea');

                    if (receiptPdfAreaElement) {
                        receiptPdfAreaElement.style.width = '768px';
                        receiptPdfAreaElement.style.maxWidth = '768px';
                        receiptPdfAreaElement.style.margin = '0 auto';
                        receiptPdfAreaElement.style.fontWeight = '500';
                        receiptPdfAreaElement.style.color = '#101010';

                        receiptPdfAreaElement.querySelectorAll('*').forEach((node: any) => {
                            node.style.opacity = '1';
                            node.style.filter = 'none';
                            node.style.textShadow = 'none';
                            node.style.fontWeight = window.getComputedStyle(node).fontWeight;
                        });
                    }
                }
            } as any).then(canvas => {

                const imgData = canvas.toDataURL('image/png', 1.0);

                const pdf = new jsPDF('p', 'mm', 'a4');
                const pdfWidth = 210;
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight, undefined, 'NONE');

                pdf.save(`Gradpilots Receipt-${this.paymentConfirmation?.orderId}-${this.paymentConfirmation?.orderSummary?.testName}.pdf`);

                this.messageService.add({
                    severity: 'success',
                    summary: 'Receipt Downloaded',
                    detail: 'Your receipt has been downloaded successfully'
                });
            });

        });
    }
}
